<section *ngIf="dashNumbers" class="highlight-our-numbers">
    <div class="container">
      
        <div class="row">
            <div class="col-md-12">
                <h2 [translate]="'landing/our-numbers'" class="sec-title">Nossos números</h2>
            </div>
        </div>
        <div class="row number-list">
            <div class="col">
                <div class="number-indicator">
                    <i class="fal fa-car-building"></i>
                    <div class="indicator">
            <span class="num">+{{dashNumbers.totalCities / 1000 | number:'1.0-0' |
                translate}}<small>Mil</small></span><br/>
                        <span [translate]="'painel-dashboard/cities'" class="what">Cidades</span>
                    </div>
                    <div [translate]="'landing/access-performance'" class="indicator-desc">
                        Conheça a performance de cada uma delas em 10 áreas de sua gestão
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="number-indicator">
                    <i class="fal fa-bullseye-pointer"></i>
                    <div class="indicator">
                        <span class="num">{{dashNumbers.totalSolutions}}</span><br/>
                        <span [translate]="'painel-dashboard/solutions'" class="what">Soluções</span>
                    </div>
                    <div [translate]="'landing/all-solutions'" class="indicator-desc">
                        Todas a soluções, ferramentas e boas práticas são validadas e pela plataforma com estimativas de
                        custo e
                        prazo para sua implementação
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="number-indicator">
                    <i class="fal fa-stream"></i>
                    <div class="indicator">
                        <span class="num">{{'landing/indicators-count' | translate}}</span><br/>
                        <span [translate]="'painel-dashboard/indicators'" class="what">Indicadores</span>
                    </div>
                    <div [translate]="'landing/all-indicators'" class="indicator-desc">
                        Todos nosso indicadores são padronizados e alinhados com os Objetivos de desenvolvimento
                        Sustentável da ONU
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="number-indicator">
                    <i class="fal fa-briefcase"></i>
                    <div class="indicator">
                        <span class="num">{{'landing/clients-count' | translate}}</span><br/>
                        <span [translate]="'landing/clients'" class="what">Clientes</span>
                    </div>
                    <div [translate]="'landing/is-present'" class="indicator-desc">
                        A Bright Cities está presente em cidades brasileiras dos mais variados tamanhos e também tem
                        atuação
                        internacional
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex align-items-center">
            <div class="col-md-12">
                <div class="transform-title">
                    <span [translate]="'landing/upgrade-city'">Transforme sua cidade</span>
                </div>
            </div>
            <div class="col-md-8">
                <h2 [translate]="'landing/creates-personalized'">A Bright Cities gera diagnósticos e roteiros
                    personalizados
                    para as cidades se tornarem mais eficientes e inteligentes.</h2>
            </div>
            <div class="col-md-4">
                <a [routerLink]="['/about-us']" class="btn btn-outline">
                    <span>{{'landing/learn-more' | translate}} <i class="far fa-chevron-right"></i></span>
                </a>
            </div>
        </div>
       
    </div>
    <div class="consultancy-section">
        <div class="container py-5">
            <div class="row justify-content-around">
                <div class="col-12 col-md-10 text-center mb-4">
                    <h3 class="consultancy-title">{{'landing/leading-consultancy' | translate}} <br class="d-lg-none"> <span class="title-highlight px-1">{{'landing/city-certification' | translate}}</span></h3>
                </div>
                <div class="col-12  mb-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-12">
                            <h5 class="text-white text-justify"><span [translate]="'landing/abnt-description'"></span></h5>
                            <h5 class="text-white text-justify"><span [translate]="'landing/abnt-description-2'"></span></h5>
                        </div>
                      
                    </div>
                </div>
              
                <div class="col-11 col-md-5">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-6 d-flex justify-content-center">
                            <img src="./assets/images/abnt.png" alt="ABNT" class="img-fluid abnt-img">
                        </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                        <div class="col-12 text-center"><span class="iso-number">ABNT NBR ISO 37120</span></div>
                        <div class="col-12 text-center mt-2 text-white">
                        {{'landing/smart-communities-iso' | translate}}
                        </div>
                    </div>
                     <div class="row justify-content-center mt-4">
                        <div class="col-12 text-center"><span class="iso-number">ABNT NBR ISO 37122</span></div>
                        <div class="col-12 text-center mt-2 text-white">{{'landing/smart-cities-iso' | translate}}</div>
                    </div>
                     <div class="row justify-content-center mt-4">
                        <div class="col-12 text-center"><span class="iso-number">ABNT NBR ISO 37123</span></div>
                        <div class="col-12 text-center mt-2 text-white">{{'landing/resilient-cities-iso' | translate}}</div>
                    </div>
                     <div class="row justify-content-center mt-4">
                        <div class="col-12 text-center"><span class="iso-number">ISO 37125</span></div>
                        <div class="col-12 text-center mt-2 text-white">{{'landing/certification/iso-37125' | translate}}</div>
                    </div>
                   
                </div>
                  <div class="col-12 col-md-5 d-flex align-items-center">
                    <app-methodology-animated [customClass]="'text-white'"></app-methodology-animated>
                </div>
           
                        <div class="col-12 d-flex justify-content-center mt-4">
                            <a class="text-underline btn btn-outline" [routerLink]="['/cities-diagnosis']"><span>{{'landing/cta-watch' | translate}} <i class="far fa-chevron-right"></i></span></a>
                        </div>

                
        
            </div>
        </div>
    </div>
</section>
